import { motion } from "framer-motion";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/useAuthStore";

const GoogleLogin = () => {
  const { setToken, setIsInternal } = useAuthStore((state) => state);
  const [cookie, setCookie] = useState("")
  const navigate = useNavigate();

  const googleLoginHandler = (e) => {
    e.preventDefault();
    window.location.href = "https://card.cyno.co.in/api/auth/login";
  };

  useEffect(() => {
    const fetchToken = () => {
      const cookies = document.cookie.split("; ").reduce((acc, c) => {
        const [key, val] = c.split("=");
        acc[key] = val;
        return acc;
      }, {});

      if (cookies.authToken) {
        console.log("Token:", cookies.authToken);
        setCookie(cookies.authToken);
      } else {
        console.log("authToken cookie not found");
      }
    };

    fetchToken();
  }, []);

  useEffect(() => {
    if (cookie) {
      setToken(cookie);
      setIsInternal(false)
      navigate("/upload");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookie]);

  return (
    <motion.div
      className="flex flex-col items-center"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl font-bold mb-6">Google Login</h1>
      <button className="bg-blue-600 text-white p-2 rounded-md" onClick={googleLoginHandler}>
        SignIn with google
      </button>
    </motion.div>
  )
}

export default GoogleLogin